export default "__VITE_ASSET__85834282__"